import React, { useEffect } from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import {
  dashboardLayoutRoutes,
  authLayoutRoutes,
  hospitalLayoutRoutes
} from "./index";

import DashboardLayout from "../layouts/Dashboard";
import AuthLayout from "../layouts/Auth";
import Page404 from "../pages/auth/Page404";
import { endInvitationOnlySession, isInvitationOnlySession } from "../services/authService";
import { SIGN_IN_ROUTE } from "./urls";

/** Ends an invitation-only session and sends it to sign-in, which asks for the invitation link. */
function LeaveInvitationOnlySession() {
  useEffect(() => { endInvitationOnlySession(); }, []);
  return <Redirect to={{ pathname: SIGN_IN_ROUTE, state: { invitationOnly: true } }} />;
}

/**
 * A dataset consumer's invitation-only session never mounts the dashboard (its API calls would all
 * be refused), however it got here: sign-in, the auto sign-in after registering, a reload.
 */
export const DashboardLayoutUnlessInvitationOnly = ({ children }) =>
  isInvitationOnlySession()
    ? <LeaveInvitationOnlySession />
    : <DashboardLayout>{children}</DashboardLayout>;

const childRoutes = (Layout, routes) =>
  routes.map(({ component: Component, guard, children, path }, index) => {
    const Guard = guard || React.Fragment;

    return children ? (
      children.map((element, index) => {
        const Guard = element.guard || React.Fragment;

        return (
          <Route
            key={index}
            path={element.path}
            exact
            render={(props) => (
              <Guard>
                <Layout>
                  <element.component {...props} />
                </Layout>
              </Guard>
            )}
          />
        );
      })
    ) : Component ? (
      <Route
        key={index}
        path={path}
        exact
        render={(props) => (
          <Guard>
            <Layout>
              <Component {...props} />
            </Layout>
          </Guard>
        )}
      />
    ) : null;
  });

let Routes;
if(import.meta.env.VITE_APP_PRODUCT === "HOSPITAL"){
    Routes = () => (
        <Switch>
            {childRoutes(DashboardLayoutUnlessInvitationOnly, hospitalLayoutRoutes)}
            {childRoutes(AuthLayout, authLayoutRoutes)} 
        
            <Route
                render={() => (
                <AuthLayout>
                    <Page404 />
                </AuthLayout>
                )}
            />
        </Switch>
    
    );
}
else{
    Routes = () => (
  
        <Switch>
        {childRoutes(DashboardLayoutUnlessInvitationOnly, dashboardLayoutRoutes)}
        {childRoutes(AuthLayout, authLayoutRoutes)}
        
        <Route
            render={() => (
            <AuthLayout>
                <Page404 />
            </AuthLayout>
            )}
        />
        </Switch>
    
    );
}

export default Routes;
